import { Icon, Box, HStack, Text, Spacer, Flex } from '@chakra-ui/react';

import { IoTimeOutline, IoChevronDown } from 'react-icons/io5';

import ContentContainer from '~/containers/Content';

type PreOrderTimeBarProps = {
  rightHandComponent?: React.ReactNode;
  onClick: () => void;
  pickMealTime: string;
};

export default function PreOrderTimeBar({
  onClick,
  pickMealTime,
  rightHandComponent,
}: PreOrderTimeBarProps) {
  return (
    <Box
      px={4}
      bgColor={pickMealTime ? 'white' : 'danger.200'}
      borderColor={pickMealTime ? 'primary' : 'danger.600'}
      borderTopWidth={1}
      borderBottomWidth={1}
      onClick={onClick}
      cursor="pointer"
    >
      <ContentContainer>
        <Flex minH="2.75rem" align="center">
          <HStack spacing={2}>
            <Icon
              as={IoTimeOutline}
              boxSize="1.5rem"
              color={pickMealTime ? 'primary' : 'danger.600'}
            />
            <Text color={pickMealTime ? 'fontSize' : 'danger.600'} fontWeight="bold" fontSize="sm">
              {pickMealTime}
            </Text>
          </HStack>
          <Spacer />
          {rightHandComponent}
        </Flex>
      </ContentContainer>
    </Box>
  );
}
